// extracted by mini-css-extract-plugin
export default {"chaptersContainer":"sDMPQ__chaptersContainer"};